import React, { Component } from 'react'
import { getValue, getBelongsToValue } from '../utils/models'
import { Divider } from 'antd'
import AutoInput from '../containers/AutoInput'
import MapForm from '../forms/MapForm'
import withValues from '../hocs/withValues'

class StopOver extends Component {

  constructor(props) {
    super(props)

    this.state = {
      showContent: false
    }
  }

  componentWillMount() {
    setTimeout(() => {
      this.setState({ showContent: true })
    }, 300)
  }

  render() {
    return (
      <div style={{ display: this.state.showContent ? 'block' : 'hidden' }}>
        {
          this.props.belongsTo.association === 'dispatch' &&
          <AutoInput
            form={this.props.form}
            model={'dispatch'}
            attribute={'dispatch'}
            value={getBelongsToValue('dispatch', this.props.belongsTo)}
            hidden
          />
        }
        <AutoInput
          value={getValue(this.props.values, 'startedAt')}
          form={this.props.form}
          model="stopover"
          attribute="startedAt"
        />
        <AutoInput
          value={getValue(this.props.values, 'finishedAt')}
          form={this.props.form}
          model="stopover"
          attribute="finishedAt"
        />
        <Divider />
        <div style={{ height: '400px', padding: '0 25px' }}>
          {this.state.showContent
            && <MapForm
              center={{
                lat: getValue(this.props.values, 'lat'),
                lng: getValue(this.props.values, 'lng')
              }}
              form={this.props.form}
              googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyBzhd2gYGYfl0bdmCeLGrOjtwzcKcfYmF0&v=3.exp&libraries=geometry,drawing,places"
              loadingElement={<div style={{ height: '100%' }} />}
              containerElement={<div style={{ height: 400, borderRadius: 3, overflow: 'hidden' }} />}
              mapElement={<div style={{ height: '100%' }} />}
            />
          }
        </div>
      </div>
    )
  }

}

export default withValues(StopOver)



// WEBPACK FOOTER //
// ./src/forms/StopOver.js